/* eslint-disable */
import { connect, StringCodec } from 'nats.ws/lib/src/mod';

export default class Square {
    config = {
      server: '',
      unionid: '',
      openid: '',
    };

    // 未读消息数，默认1（1为假数据）
    unreadMsgCount = 1;

    // 自己的消息
    ownMsgList = [];

    // 同城的消息
    nearbyMsgList = [];

    nc = null;
    sub = null;
    sc = StringCodec();

    constructor(config) {
        this.config = {
            ...this.config,
            ...config,
        };
    }

    sendMsg(target, msgObj) {
        this.nc.publish(target, msgObj);
    }

    getOwnMsgList() {
        return this.ownMsgList;
    }

    getNearbyMsgList() {
        return this.nearbyMsgList;
    }

    async createConnect() {
      this.nc = await connect({
          servers: this.config.server,
      });
    }

    async subscribe() {
      if (this.nc && this.config.unionid) {
        this.sub = this.nc.subscribe(this.config.unionid.toLowerCase());
      }
    }
    
    async receiveMsg(callback) {
        let subj = this.sub.getSubject();
        console.log(`listening for ${subj}`);
        for await (const m of this.sub) {
            console.log(
                `${m.subject} ${
                    m.data ? " " + this.sc.decode(m.data) : ""
                }`,
            );
            callback && callback(m.data)
        }
    }
}

